/**
 * Default primary color throughout the GitBook ecosystem.
 */
export const DEFAULT_PRIMARY_COLOR = '#346DDB';
/**
 * The darkest color that exists in GitBook, used as the relative minimum of every generated color scale.
 */
export const DARK_BASE = '#1D1D1D';
/**
 * The lightest color that exists in GitBook, used as the relative maximum of every generated color scale.
 */
export const LIGHT_BASE = '#FFFFFF';
/**
 * Used as the basis of all UI elements that are not colored by the primary color. Neutral gray by default, overridden by site customization.
 */
export const DEFAULT_TINT_COLOR = '#787878';
/**
 * Used for informational messages and neutral alerts.
 */
export const DEFAULT_HINT_INFO_COLOR = '#787878';
/**
 * Used for showing important information or non-critical warnings.
 */
export const DEFAULT_HINT_WARNING_COLOR = '#FE9A00';
/**
 * Used for destructive actions or raising attention to critical information.
 */
export const DEFAULT_HINT_DANGER_COLOR = '#FB2C36';
/**
 * Used for showing positive actions or achievements.
 */
export const DEFAULT_HINT_SUCCESS_COLOR = '#00C950';
